import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  careerObject: {},
  careerResultObject: {},
  careerOneStopInfo: {},
  geoIdMap: {}
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/career/vuex/index.js